export const AUTH_STATE = {
  LOGGED_IN: 'logged-in',
  LOGGED_OUT: 'logged-out',
};
